// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// event-summary-best-time-recurrence imports
import { eventSummaryBestTimeRecurrenceFragments } from "./EventSummaryBestTimeRecurrence.gql";
import { EventSummaryRow as s } from "./EventSummary.styles";
// util
import { EFlex } from "@util/event-tag.util";
import { getAutopilotTime } from "@clockwise/client-commons/src/util/event-recurrence";
// material-ui
import { Autorenew } from "@material-ui/icons";
// styles
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

interface IProps {
  color?: string;
  event: ISchema.IEvent;
  selectedFlex?: EFlex;
}
const EventSummaryBestTimeRecurrenceCmpt = (props: IProps) => {
  const { color, event, selectedFlex } = props;
  const recurrence = getAutopilotTime(event, selectedFlex || EFlex.Pin);

  return (
    <div style={{ ...s.container, alignItems: "flex-start" }}>
      <Autorenew style={{ ...s.icon, color }} htmlColor={color || s.icon.color} />
      <div style={{ ...s.text, color: color || colors.green.standard }}>{recurrence}</div>
    </div>
  );
};

export const EventSummaryBestTimeRecurrence = createFragmentContainer<IProps>(
  EventSummaryBestTimeRecurrenceCmpt,
  eventSummaryBestTimeRecurrenceFragments,
);
